import { transport } from 'config/transport';

export function callApiDeleteDanhMucThu(congDoanId, danhMucThuId) {
    return transport.del(`/mamnon/${congDoanId}/thuhocsinh/danhmucthu/${danhMucThuId}`);
}
